export default {
  unavailable: 'This block is no longer available and will be left out of the report.',
  onlyIncludedFor: 'Only included when exported for: {scopes}',
  configuration: 'Configuration',
  template: 'Template',
  replaced: 'Replaced',
  default: 'Default',
  variables: 'Variables',
};
